<template>
	<div>
		<md-dialog :md-active.sync="showDialog">
			<md-dialog-title>Search Members</md-dialog-title>
			<md-field md-clearable class='searcher'>
				<label v-if="section !== 'members'">Existing member or email</label>
				<label v-else>Existing member or new email</label>
				<md-input v-model="searchText" @keyup.enter='quickSearch' @input="sanitizeSearchText($event)"></md-input>
			</md-field>
				<multi-member-picker v-if="searchResults.length >0" v-on:changed="updateSelected" :members="searchResults" :selected="selected" :admin="selectionProp" :iconName="iconName">Advisors goes here...</multi-member-picker>
			<md-dialog-actions>
				<md-button class="md-primary" @click="cancel()">Cancel</md-button>
				<template v-if="editAsk">
					<md-button class="md-primary" @click="choose()" :disabled="selected.length <= 0">save</md-button>
				</template>
				<template v-else>
          <md-button class="md-primary" v-if="searchResults.length > 0 && section == 'members'" @click="choose()" :disabled="selected.length <= 0">Choose</md-button>
          <md-button class="md-primary" v-else-if="(section == 'members' || section == 'addAsk') && emailPattern.test(searchText) && (searchResults.length == 0)" @click="addMember()">Add New Member</md-button>
          <md-button class="md-primary" v-else @click="choose()" :disabled="selected.length <= 0">Choose</md-button>
				</template>
			</md-dialog-actions>
		</md-dialog>
		<div class="picker-icon picker-name" @click="showDialog = true">
			<template v-if="editAsk">
				<font-awesome-icon class='small-icon' icon="pencil-alt" />
			</template>
			<template v-else>
				<font-awesome-icon class='small-icon' icon="plus-circle" /> <span>{{iconName}}</span>
			</template>
		</div>
	</div>
</template>

<script>
import API from "../services/API";
import MultiMemberPicker from "./MultiMemberPicker";
import { sanitizeInput } from '../utils/sanitizer';

export default {
  name: "MemberPicker",
  props: ['selectionType', 'iconName', 'editAsk', 'section', 'community'],
  components: {
    MultiMemberPicker
  },
  data: () => ({
    api: new API(),
    showDialog: false,
    searchText: "",
    selected: [],
    searchResults: [],
    selectionProp: '',
    emailPattern: /\S+@\S+\.\S+/
  }),
  watch: {
	searchText(newVal) {
      if (!newVal) {
        // Clear the search results when searchText is cleared.
        this.searchResults = [];
		this.selected = [];
      }
    }
  },
  mounted() {
	  	this.searchResults = [];
	  	this.searchText = '';
  		this.selectionProp = this.selectionType;
  },
  methods: {
	sanitizeSearchText(e) {
      this.searchText = sanitizeInput(e);
    },
    cancel: function() {
		this.searchResults = [];
		this.searchText = '';
      	this.showDialog = false;
    },
    updateSelected: function(selectedList) {
      	this.selected = selectedList;
      	this.selectionProp = this.selectionType;
    },
    choose: function() {
      	var res = this.selected.length > 0 ? this.selected : [this.searchText];
      	this.$emit("chosen", res);
      	this.showDialog = false;
    },
    quickSearch: async function() {
	  	if (this.selectionType === 'administrators') {
        	this.$emit('administrator');
      	}
      	var minLength = 1;
      	if (this.section === 'administrators' || this.section === 'addAsk') {
			if (this.searchText.length < minLength) {
	          	this.searchResults = [];
	        } else {
				let url = `members/search-community-members?term=${this.searchText}&community_id=${this.community}&limit=4&ignoreUnsubscribed=true`;
	          	await this.api.get(url).then(members => {
					this.searchResults = members.data;
				});
	        }
		} else if (this.section === 'advisers') {
        	if (this.searchText.length < minLength) {
          		this.searchResults = [];
        	} else {
          		await this.api.get(`members/search-community-advisers?term=${this.searchText}&community_id=${this.community}&limit=4`).then(members => {
              	this.searchResults = members.data;
            	});
        	}
      	} else {
			if (this.searchText.length < minLength) {
          		this.searchResults = [];
        	} else {
          	this.api.get(`members/search?term=${this.searchText}&limit=4`).then(members => {
				if (members.data && members.data.members) {
                	this.searchResults = members.data.members;
              	}
            });
        }
      }
    },
    addMember: async function() {
      await this.api
      .post(`members/community-create-member`, {email: this.searchText, community: this.community})
      .then(members => {
        if (Array.isArray(members.data) && members.data.length) {
          this.$router.push(`/members/${members.data[0]._id}`);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MemberPicker.vue